import { request } from "./http";

/** Standard REST resource: GET /x, GET /x/:id, POST /x, PUT /x/:id, DELETE /x/:id */
export const makeCrud = (resource) => ({
  list:   (params, signal) => request(`/${resource}`, { params, signal }),
  get:    (id)             => request(`/${resource}/${id}`),
  create: (body)           => request(`/${resource}`, { method: "POST", body }),
  update: (id, body)       => request(`/${resource}/${id}`, { method: "PUT", body }),
  remove: (id)             => request(`/${resource}/${id}`, { method: "DELETE" }).then(() => true),
});
